import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../utils/firebase";
import { useCurrentScreen } from "./useCurrentScreen";
import useAuth from "./useAuth";
import { ANALYTICS_EVENTS } from "../constants/analytics";

function useScreenTracking() {
  const { name: screenName, params } = useCurrentScreen();
  const { authUser, userId, loading } = useAuth();

  useEffect(() => {
    if (loading) {
      return;
    }
    const screenClass = `Page${screenName.replace(" ", "")}`;

    console.log("[useScreenTracking]", {
      firebase_screen: screenName,
      firebase_screen_class: screenClass,
      user_id: userId,
      auth_user_id: authUser!.uid,
      ...params,
    });

    logEvent(analytics, ANALYTICS_EVENTS.SCREEN_VIEW, {
      firebase_screen: screenName,
      firebase_screen_class: screenClass,
      user_id: userId,
      auth_user_id: authUser!.uid,
      ...params,
    });
  }, [authUser, loading, params, screenName, userId]);
}

export default useScreenTracking;
